module.exports = __webpack_public_path__ + "img/ol_bg1.24f49838.jpg";